import { render, staticRenderFns } from "./DeliveryVariants.vue?vue&type=template&id=1987088a&"
import script from "./DeliveryVariants.vue?vue&type=script&lang=js&"
export * from "./DeliveryVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports